import React, { useState } from "react";

import Box from "../components/base/box";

import { useContentContext } from "../context/content-context";

import PatientPageWrapper from "./components/patient-page-wrapper";
import FAQItem from "./components/faq-item";

const FAQPage = () => {
  const { content, faqs, references } = useContentContext();

  const [expandedFaq, setExpandedFaq] = useState(null);

  return (
    <PatientPageWrapper references={references}>
      <section className="section-outer background-light-teal">
        <Box minHeight="500px" className="section-inner column faq-section">
          {faqs?.map((faq) => (
            <FAQItem
              key={faq.question}
              {...faq}
              isExpanded={expandedFaq === faq}
              setIsExpanded={() => setExpandedFaq(faq)}
              setIsntExpanded={() => setExpandedFaq(null)}
            />
          ))}
        </Box>
      </section>
      <div dangerouslySetInnerHTML={{ __html: content?.join("") }} />
    </PatientPageWrapper>
  );
};

export default FAQPage;
